module.exports = __webpack_public_path__ + "img/premier-web__content-creation_and_layout.ab999524.jpg";